export default ({title}) => <>
    <b>Multiple config</b>
    <hr/>
</>
